

export default {

    intervalID: null,
    eventBegin: null,

    init() {


        // Do not start the countdown if we are not at the home page.
        if (!window.eventBegin || !document.getElementById('countdown')) {
            return
        }

        this.eventBegin = window.eventBegin

        //this.currentTime = new Date(countdownTimes.currentTime).getTime()
        //this.currentTime = new Date()

        // sftBegin is not used anymore
        // this.sftBegin = countdownTimes.sftBegin

        // The delta between server time and browser time
        // Can be used to sync the clock if it runs badly.
        // Not used at the moment.
        // this.delta = Math.floor(Date.now() / 1000) - this.currentTime

        const remaining = this.getTimeRemaining(/*this.currentTime*/)
        if (remaining.total > 0) {
          this.intervalID = window.setInterval(() => { this.updateClock() }, 1000)
          this.updateClock()
        }


    },

    updateClock() {
        //this.currentTime++
        const remaining = this.getTimeRemaining(/*this.currentTime*/)
        if (remaining.total <= 0) {
            window.clearInterval(this.intervalID)
            window.location.href = '/event-info/visitors'
        }

        if (remaining.days[0] === '0') {
            document.getElementById('countdown-days-1').style.display = 'none'
        }

        document.getElementById('countdown-days-1').innerHTML = remaining.days[0]
        document.getElementById('countdown-days-2').innerHTML = remaining.days[1]
        document.getElementById('countdown-days-3').innerHTML = remaining.days[2]
        document.getElementById('countdown-hours-1').innerHTML = remaining.hours[0]
        document.getElementById('countdown-hours-2').innerHTML = remaining.hours[1]
        document.getElementById('countdown-minutes-1').innerHTML = remaining.minutes[0]
        document.getElementById('countdown-minutes-2').innerHTML = remaining.minutes[1]
        document.getElementById('countdown-seconds-1').innerHTML = remaining.seconds[0]
        document.getElementById('countdown-seconds-2').innerHTML = remaining.seconds[1]
    },

    getTimeRemaining(now) {
        //const begin   = new Date(2024, 0, 21, 0, 0, 0).getTime()
        //const begin   = new Date(2024, 0, 16, 1, 28, 0).getTime()
        const begin   = Date.parse(this.eventBegin)
        const current = new Date().getTime()
        let t = (begin - current) / 1000

        if (t < 0) {
            t = 0
        }

        const seconds = Math.abs(Math.floor( t % 60 ));
        const minutes = Math.abs(Math.floor( (t / 60) % 60 ));
        const hours   = Math.abs(Math.floor( (t / (60 * 60)) % 24 ));
        const days    = Math.abs(Math.floor( t / (60 * 60 * 24) ));

        return {
            'total': t,
            'days': this._digitze(days, 3),
            'hours': this._digitze(hours, 2),
            'minutes': this._digitze(minutes, 2),
            'seconds': this._digitze(seconds, 2),
        };
    },

    _digitze(val, digits) {
        val = val.toString()
        while (val.length < digits) {
            val = '0' + val
        }
        return val
    }
}
